import { env } from './env';

if (!env.api.ORDER_MGMT_API_URL) {
    throw new Error('VITE_ORDER_MGMT_API_URL is not configured. Set it in your .env file.');
}

export const apiConfig = {
    baseUrl: `${env.api.ORDER_MGMT_API_URL.replace(/\/+$/, '')}`,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
};

